/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { replacePXinStringWithEM, pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : GIPHY : STYLES --------------- ++++++++++ */
export default theme => ({
	giphys: {
		
	}
});
